import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(
    private http: HttpClient
  ) { }

  get(url: any, data?: any): Observable<any> {
    return this.http.get(url, data);
  }
  put(url: string, data: any): Observable<any> {
    return this.http.put(url, data);
  }
  post(url: string, data: any): Observable<any> {
    return this.http.post(url, data);
  }
  delete(url: string): Observable<any> {
    return this.http.delete(url);
  }
}
